import React from 'react'
import { Form, Typography, Select } from 'antd'
import { map } from 'lodash-es'
import { scrapingTestCaseTagsFormInitialValues } from './initial-values'
import { scrapingTestCaseTagsFormRules } from './rules'
import PropTypes from 'prop-types'

const ScrapingTestCaseTagsForm = ({
  tags,
  tagsForTestCase,
  onSubmit,
  formRef,
}) => {
  const initialValues = scrapingTestCaseTagsFormInitialValues(tagsForTestCase)

  const options = map(tags, ({ id, name }) => ({
    label: name,
    value: id,
  }))

  return (
    <Form
      initialValues={initialValues}
      onFinish={onSubmit}
      form={formRef}
      preserve={false}
      scrollToFirstError
    >
      <Form.Item
        label="Custom"
        name="customTagIds"
        rules={scrapingTestCaseTagsFormRules.customTagIds}
      >
        <Select options={options} mode="multiple" />
      </Form.Item>
      <Form.Item label="Menu structure">
        <Typography.Text>{initialValues.menuStructure}</Typography.Text>
      </Form.Item>
      <Form.Item label="Menu type">
        <Typography.Text>{initialValues.menuType}</Typography.Text>
      </Form.Item>
      <Form.Item label="Menu">
        <Typography.Text>{initialValues.menu}</Typography.Text>
      </Form.Item>
      <Form.Item label="Menu list">
        <Typography.Text>{initialValues.menuList}</Typography.Text>
      </Form.Item>
      <Form.Item label="Section list">
        <Typography.Text>{initialValues.dishList}</Typography.Text>
      </Form.Item>
      <Form.Item label="Global">
        <Typography.Text>{initialValues.Global}</Typography.Text>
      </Form.Item>
    </Form>
  )
}

ScrapingTestCaseTagsForm.propTypes = {
  tags: PropTypes.array.isRequired,
  tagsForTestCase: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formRef: PropTypes.object.isRequired,
}
export default ScrapingTestCaseTagsForm
